import * as React from 'react';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '../../../../../types/product.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import 'classnames';
import { PriceSection } from '../../../components/PriceSection/PriceSection.js';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';
import { useFramesPriceFrom } from '../../hooks/use-frames-price-from.js';

const FramesPriceSection = ()=>{
    var ref, ref1;
    const { activeVariant: { bestPrice  } ,  } = useProductData();
    const { displayPrice  } = useFramesEcommContext();
    const { shouldDisplayFromPrice , fromPricePrefix  } = useFramesPriceFrom();
    return /*#__PURE__*/ React.createElement(PriceSection, {
        originalPrice: displayPrice.originalPrice,
        orignalPriceCurrencyCode: displayPrice.currency,
        discountedPrice: displayPrice.discountedPrice,
        discountBadge: (ref = displayPrice.discountInfo) === null || ref === void 0 ? void 0 : ref.discountBadge,
        discountDescription: (ref1 = displayPrice.discountInfo) === null || ref1 === void 0 ? void 0 : ref1.discountDescription,
        bestPrice: bestPrice,
        shouldDisplayFromPrice: shouldDisplayFromPrice,
        fromPricePrefix: fromPricePrefix
    });
};

export { FramesPriceSection };
//# sourceMappingURL=FramesPriceSection.js.map
